import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import List from 'xgimi-ui/mui/material/List';
import { HttpStateLine } from 'state-line';
import Input from 'xgimi-ui/mui/material/Input';
import images from '@/assets/images';
import { InfoSelectOption } from 'xgimi-ui/Info/Select';
import Dialog from 'xgimi-ui/Dialog';

import Button from 'xgimi-ui/Button';
import Api from '@/api';
import StoreComponent, { mapStateToProps } from '../../../appComponents/Store';

import s from './.module.scss';

interface Props {
  // 是否打开
  open: boolean;
  // 设备
  device: string;
  // 串号
  sn: string;
  // 关闭回调
  onClose: () => void;
  // 确认
  onConfirm: (device: string, sn: string, isInput: boolean) => void;
  // 设备列表
  deviceList: InfoSelectOption[];
  // 绑定设备列表
  bindDeviceList: Record<string, any>[];
  // 是否手动输入
  isInput: boolean;
}

interface State {
  // 设备名
  device: string;
  // 串号
  sn: string;
  // 是否是手动输入
  isInput: boolean;
  // 当前选中机器
  currentSelect: string;
  // 是否点击切换
  isDuration: boolean;
}

/**
 * 选择设备
 */
class Component extends StoreComponent<Props, State> {
  state: State = {
    device: '',
    sn: '',
    isInput: false,
    currentSelect: '',
    isDuration: false,
  };

  componentDidMount() {
    // --- 监听 ---
    this.watch('open', () => this.props.open, () => {
      if (this.props.open) {
        this.setState({
          device: this.props.device,
          sn: this.props.sn,
          isInput: this.props.isInput,
          currentSelect: `${this.props.device}-${this.props.sn}`,
        });
      }
    });
  }

  /**
   * 点击确认
   */
  private onConfirm = (): void => {
    // 判断输入的序列号是否12位字符
    if (this.state.isInput) {
      if (!this.state.sn) {
        this.storeState.common.toast.current?.show({ content: '请输入序列号' });
      } else {
        new HttpStateLine(new (Api.feedback.GetProductNameBySn)({
          sn: this.state.sn,
        }), {
          onSuccess: (stateLine) => {
            if (!!stateLine.result.data.productSn) {
              this.setState({ device: stateLine.result?.data?.productName }, () => {
                // 根据当前操作页面返回对应值
                this.props.onConfirm(this.state.device, this.state.sn, this.state.isInput);
              });
            } else {
              this.storeState.common.toast.current?.show({ content: '序列号错误' });
            }
          },
        }).run();
      }
    } else {
      const data = this.state.currentSelect.split('-');
      // 根据当前操作页面返回对应值
      this.props.onConfirm(data[0], data[1], this.state.isInput);
    }
  };

  private clickInput = () => {
    const input = document.querySelector('#input');
    input?.addEventListener('focus', () => {
      setTimeout(() => {
        input?.scrollIntoView(false);
      }, 300);
    });
  };

  render(): React.ReactNode {
    return (
      <Dialog
        isOpen={this.props.open}
        isResponsive={true}
        isAutoClose={true}
        onClose={this.props.onClose}
        classes={{ paper: s.dialogPaper, container: s.dialogContainer }}
      >
        <div className={this.getClassName([s.container, this.state.isInput && s.inputContainer])}>
          <div className={s.content}>
            <div className={s.operation}>
              <div onClick={this.props.onClose}><img src={images.iconError} alt="" width={24} height={24}/></div>
            </div>
            <div className={s.dialogTitle}>选择反馈设备</div>
            {/* 是否是手动输入 */}
            {this.state.isInput
              ? (
                <div className={this.getClassName([this.state.isDuration && s.duration])}>
                  <Input
                    classes={{ input: s.input }}
                    id={'input'}
                    className={this.getClassName([s.input, s.inputContainer])}
                    placeholder={'输入设备底部序列号'}
                    disableUnderline={true}
                    onChange={(event) => this.setState({ sn: event.target.value })}
                    value={this.state.sn}
                    onClick={this.clickInput}
                  />
                </div>
              )
              : (
                <List classes={{ root: s.listRoot }} className={this.getClassName([this.state.isDuration && s.duration])}>
                  {this.props.bindDeviceList?.map((item, index) => (
                    <Fragment key={index}>
                      <div
                        className={s.deviceItem}
                        onClick={() => {
                          this.setState({ currentSelect: `${item.productName}-${item.sn}` });
                        }}
                      >
                        <span className={s.deviceName}>{`${item.productName}-${item.sn}`}</span>
                        {this.state.currentSelect === `${item.productName}-${item.sn}` && (
                          <div>
                            <img src={images.iconCorrect} alt="" width={24} height={24}/>
                          </div>
                        )}
                      </div>
                    </Fragment>
                  ))}
                </List>
              )}
          </div>
          <div className={s.buttonArea}>
            <Button
              color={'#000004'}
              className={s.button}
              disableElevation={true}
              onClick={this.onConfirm}
            >
              确定
            </Button>
            {
              this.state.isInput ? (
                <div
                  className={s.tips}
                  onClick={() => {
                    if (this.props.bindDeviceList.length === 0) {
                        this.storeState.common.toast.current?.show({ content: '当前暂无绑定设备' });
                    } else {
                      this.setState({ isInput: false, isDuration: true });
                      setTimeout(() => {
                        this.setState({ isDuration: false });
                      }, 300);
                    }
                  }}
                >
                  选择已绑定设备
                </div>
              ) : (
                <div
                  className={s.tips}
                  onClick={() => {
                    this.setState({ isInput: true, device: '', sn: '', isDuration: true });
                    setTimeout(() => {
                      this.setState({ isDuration: false });
                    }, 300);
                  }}
                >
                  手动添加其他设备
                </div>
              )
            }
          </div>
        </div>
      </Dialog>
    );
  }
}

export default connect(mapStateToProps)(Component);
